export enum TipoUsuarioEnum {
	noUser = 'noUser',
	// The following are the possible user types in the system
	admin = 'admin',
	colegio = 'colegio',
	estudiante = 'estudiante',
	profesor = 'profesor',
	monitor = 'monitor',
	coordinador = 'coordinador'
}
